import "/__w/1/s/BotFramework-WebChat/packages/component/src/providers/CustomElements/customElements/CodeBlockCopyButton.module_built.css";
const classes = {"code-block-copy-button":"wGHOKkG_code-block-copy-button","code-block-copy-button__icon":"wGHOKkG_code-block-copy-button__icon","code-block-copy-button--copied":"wGHOKkG_code-block-copy-button--copied","code-block-copy-button__icon--copied":"wGHOKkG_code-block-copy-button__icon--copied"}
export default classes

const _code_block_copy_button0 = classes["code-block-copy-button"]
export { _code_block_copy_button0 as "code-block-copy-button" }

const _code_block_copy_button__icon0 = classes["code-block-copy-button__icon"]
export { _code_block_copy_button__icon0 as "code-block-copy-button__icon" }

const _code_block_copy_button__copied0 = classes["code-block-copy-button--copied"]
export { _code_block_copy_button__copied0 as "code-block-copy-button--copied" }

const _code_block_copy_button__icon__copied0 = classes["code-block-copy-button__icon--copied"]
export { _code_block_copy_button__icon__copied0 as "code-block-copy-button__icon--copied" }
